import { render } from "./TV-App.vue?vue&type=template&id=cad8a9b2"
import script from "./TV-App.vue?vue&type=script&lang=js"
export * from "./TV-App.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__